<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="6" class="mt-8">
        <v-card v-on:keyup.enter="submit()" v-if="!registered">
          <v-card-text class="text-center">
            <img
              class=" mx-auto d-block logo"
              :src="logo"
              alt="PinPoint Logo"
            />
            <div class="d-flex align-center justify-center" v-if="errorText">
              <v-icon color="error">mdi-alert-circle</v-icon>
              <span class="text-subtitle-1 font-weight-medium ml-1">
                {{ errorText }}
              </span>
            </div>
            <v-form ref="form" v-model="isValid">
              <v-text-field
                :prepend-icon="'mdi-account-circle'"
                placeholder="User ID"
                :rules="[rules.required]"
                v-model="registrationData.username"
              ></v-text-field>
              <v-text-field
                :prepend-icon="'mdi-email'"
                placeholder="Email address (optional)"
                v-model="registrationData.email"
              ></v-text-field>
              <v-text-field
                :prepend-icon="'mdi-card-account-details-outline'"
                placeholder="First Name (optional)"
                v-model="registrationData.first_name"
              ></v-text-field>
              <v-text-field
                :prepend-icon="'mdi-card-account-details'"
                placeholder="Last Name (optional)"
                v-model="registrationData.last_name"
              ></v-text-field>
              <v-text-field
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show1 = !show1"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                :prepend-icon="'mdi-lock'"
                placeholder="Password"
                hint="At least 8 characters"
                v-model="registrationData.password"
              ></v-text-field>
              <v-text-field
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show1 = !show1"
                :rules="[rules.required, rules.passwordMatch, rules.min]"
                :type="show1 ? 'text' : 'password'"
                :prepend-icon="'mdi-lock'"
                placeholder="Confirm Password"
                v-model="confirmPassword"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="d-flex justify-space-between pb-4 mx-2">
            <router-link :to="{ name: 'Login' }">
              <v-btn outlined>Cancel</v-btn>
            </router-link>
            <v-btn @click="register()" color="primary" :disabled="!isValid">
              Register
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-if="registered && registeredSuccess">
          <v-card-title>You have successfully registered.</v-card-title>
          <v-card-subtitle>You may now log in</v-card-subtitle>
          <div class="text-center pb-4">
            <router-link :to="{ name: 'Login' }">
              <v-btn color="primary">Login Page</v-btn>
            </router-link>
          </div>
        </v-card>
        <!-- <v-card v-if="registered && !registeredSuccess">
          An error has occurred
        </v-card> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import PinPointLogo from "../../../assets/RadectPinpointLogo.png";
import RadectLogo from "../../../assets/RadectHealthLogoLarge.svg";
import { sendRegistrationDataApiCall } from "../api";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      registrationData: {
        username: "",
        email: "",
        password: "",
        first_name: "",
        last_name: ""
      },
      confirmPassword: "",
      registered: false,
      registeredSuccess: false,
      logo: RadectLogo,
      isValid: false,
      show1: false,
      errorText: "",
      rules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Min 8 characters",
        passwordMatch: v =>
          v === this.registrationData?.password || "Password mismatch"
      }
    };
  },

  created() {},

  computed: {
    ...mapGetters({})
  },
  methods: {
    register() {
      if (this.$refs.form.validate()) {
        // console.log('registration ', this.registrationData);
        // this.$store.dispatch('sendRegistrationData', this.registrationData)
        sendRegistrationDataApiCall(this.registrationData)
          .then(res => {
            if (res.data.Error) {
              this.errorText = res.data.Error;
            } else {
              this.registered = true;
              this.registeredSuccess = true;
            }
          })
          .catch(e => {
            this.errorText = e.response.data.detail;
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
a {
  text-decoration: none;
}
.logo {
  max-height: 200px;
  max-width: 100%;
}
</style>
